import { componentClasses } from "../../../core/components/file-input/file-input";
import { deepMerge } from "../../../core/js/utilities";

const defaultProps = {
    children: "",
    sROnlyText: "",
};

export const fileInputListTemplate = (props = defaultProps) => {
    const mergedProps = deepMerge(defaultProps, props);

    return `
    <ul class="${componentClasses.list}" aria-live="polite">${mergedProps.children}
    <div aria-live="polite" class="dds__file-input__sr-only"></div>
    </ul>
    
`;
};
